









import { Vue, Component, Prop } from "vue-property-decorator";
import { Activity } from "@/graphql/query/activity/feed";
import { BuildingLink, RoomLink } from "./helper";

@Component({ components: { BuildingLink, RoomLink } })
export default class CreateTelKeyLog extends Vue {
  @Prop({ type: Object, required: true }) activity!: Activity;
}
